import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Box, Typography } from '../mui/Core/index'
import { CheckCircle } from '../mui/Icons/index'
import * as Constants from '../../constants/en.json'
import { regexPatterns } from '../../constants/regex'

function PasswordValidation({ value, handlePasswordValidation }) {
  const [lowerValidated, setLowerValidated] = useState(false)
  const [upperValidated, setUpperValidated] = useState(false)
  const [numberValidated, setNumberValidated] = useState(false)
  const [specialValidated, setSpecialValidated] = useState(false)
  const [lengthValidated, setLengthValidated] = useState(false)
  const [isValid, setIsValid] = useState(false)

  useEffect(() => {
    const setValidation = () => {
      if (
        lowerValidated &&
        upperValidated &&
        numberValidated &&
        specialValidated &&
        lengthValidated
      ) {
        setIsValid(true)
      } else {
        setIsValid(false)
      }
      handlePasswordValidation(isValid)
    }
    setLowerValidated(regexPatterns.lowerCase.test(value))
    setUpperValidated(regexPatterns.upperCase.test(value))
    setNumberValidated(regexPatterns.isNumber.test(value))
    setSpecialValidated(regexPatterns.isSpecial.test(value))
    setLengthValidated(regexPatterns.passwordLength.test(value))

    setValidation()
  }, [
    handlePasswordValidation,
    isValid,
    lengthValidated,
    lowerValidated,
    numberValidated,
    setIsValid,
    setLengthValidated,
    setLowerValidated,
    setNumberValidated,
    setSpecialValidated,
    setUpperValidated,
    specialValidated,
    upperValidated,
    value,
  ])

  const ruleWrapperStyle = {
    display: 'flex',
    alignItems: 'center',
  }

  const boxStyle = {
    width: '250px',
  }

  const checkStyle = {
    fontSize: '20px',
    pr: '4px',
    pb: '2px',
    height: '25px',
  }

  return (
    <Box sx={boxStyle}>
      <Typography variant='smallSubtitle'>{Constants.passwordRules.PASSWORD_MUST}</Typography>
      <Box sx={ruleWrapperStyle}>
        {lengthValidated ? (
          <CheckCircle sx={checkStyle} color='success' />
        ) : (
          <CheckCircle sx={checkStyle} color='disabled' />
        )}
        <Typography variant='smallSubtitle'>{Constants.passwordRules.BE_11_CHARACTERS}</Typography>
      </Box>
      <Box sx={ruleWrapperStyle}>
        {numberValidated ? (
          <CheckCircle sx={checkStyle} color='success' />
        ) : (
          <CheckCircle sx={checkStyle} color='disabled' />
        )}
        <Typography variant='smallSubtitle'>{Constants.passwordRules.INCLUDE_NUMBER}</Typography>
      </Box>
      <Box sx={ruleWrapperStyle}>
        {upperValidated ? (
          <CheckCircle sx={checkStyle} color='success' />
        ) : (
          <CheckCircle sx={checkStyle} color='disabled' />
        )}
        <Typography variant='smallSubtitle'>{Constants.passwordRules.INCLUDE_UPPERCASE}</Typography>
      </Box>
      <Box sx={ruleWrapperStyle}>
        {lowerValidated ? (
          <CheckCircle sx={checkStyle} color='success' />
        ) : (
          <CheckCircle sx={checkStyle} color='disabled' />
        )}
        <Typography variant='smallSubtitle'>{Constants.passwordRules.INCLUDE_LOWER}</Typography>
      </Box>
      <Box sx={ruleWrapperStyle}>
        {specialValidated ? (
          <CheckCircle sx={checkStyle} color='success' />
        ) : (
          <CheckCircle sx={checkStyle} color='disabled' />
        )}
        <Typography variant='smallSubtitle'>{Constants.passwordRules.INCLUDE_SYMBOL}</Typography>
      </Box>
    </Box>
  )
}

PasswordValidation.propTypes = {
  value: PropTypes.string.isRequired,
  handlePasswordValidation: PropTypes.func.isRequired,
}

export default PasswordValidation
